module.exports = __webpack_public_path__ + "img/d.faa47546.png";